import { getManagerImage, getManagerEmoji } from '../../utils/managers';
import { castKey, castSrc } from '../../data/cast';
import CastFigure from '../../motion/CastFigure';

const SIZES = {
  xs: 'w-9 h-9 text-base',
  sm: 'w-11 h-11 text-lg',
  md: 'w-14 h-14 text-2xl',
  lg: 'w-20 h-20 text-4xl',
  xl: 'w-32 h-32 text-6xl',
  hero: 'w-52 h-52 text-8xl',
};

// Round cream disc with the manager's cut-out. Hover plays a short pose sequence on the larger sizes.
export default function ManagerAvatar({
  name,
  size = 'md',
  framed = false,
  className = '',
}) {
  const key = castKey(name);
  const image = getManagerImage(name);
  const emoji = getManagerEmoji(name);
  const sizeClass = SIZES[size] || SIZES.md;
  const frameClass = framed ? 'border-2 border-accent-gold' : '';
  const big = size === 'lg' || size === 'xl' || size === 'hero';

  const legacyUrl = image ? `/images/managers/${encodeURIComponent(image)}` : null;

  return (
    <div
      aria-label={`${name} avatar`}
      className={`${sizeClass} ${frameClass} rounded-full overflow-hidden flex items-end justify-center ${key ? 'bg-[#fbf8f2]' : 'bg-bg-elevated'} ${className}`}
    >
      {key ? (
        big ? (
          <CastFigure name={name} alt={name} trigger="hover" sequence={['shock', 'point', 'smug']} className="w-[92%] h-[96%] translate-y-[3%]" />
        ) : (
          <img src={castSrc(key, 'base')} alt={name} className="w-[92%] h-[96%] object-contain object-bottom translate-y-[3%]" draggable="false" />
        )
      ) : legacyUrl ? (
        <img src={legacyUrl} alt={name} className="w-full h-full object-cover" />
      ) : (
        <span aria-label={name} className="self-center">{emoji}</span>
      )}
    </div>
  );
}
